import onlineRequest from '@/utils/request'

const api = {
  getMoney: '/op/rom/getMoney', // 获取余额
  updateUser: '/op/user/update', // 更改用户信息
  infoUser: '/op/user/info', // 获取用户信息
  withdrawalSave: '/op/rom/withdrawalSave',
  withdrawalList: '/op/rom/withdrawalList'
}
export function infoUser (id) {
  return onlineRequest({
    url: `${api.infoUser}?id=${id}`,
    method: 'get'
  })
}
export function updateUser (params) {
  return onlineRequest({
    url: api.updateUser,
    method: 'post',
    data: params
  })
}
export function getMoney (params) {
  return onlineRequest({
    url: api.getMoney,
    method: 'post',
    data: params
  })
}
export function withdrawalSave (params) {
  return onlineRequest({
    url: api.withdrawalSave,
    method: 'post',
    data: params
  })
}
export function withdrawalList (params) {
  return onlineRequest({
    url: api.withdrawalList,
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/money.js